
import { createAsyncThunk } from "@reduxjs/toolkit";
import { postData } from "../../../apiservice/apis";

export const fetchManufacturingRecord = createAsyncThunk(
  "manufacturingRecord/fetch",
  async ({ selectedFilterType, selectedRecordType, filters }, { rejectWithValue }) => {
    try {
      let url = "manufacturing/get-manufacturing-record";
      if (selectedRecordType === "with item") {
        url = "manufacturing/get-manufacturing-record-with-details";
      }
      if (
        selectedFilterType &&
        ["By Item", "By Tag", "By Group", "By Category"].includes(selectedFilterType)
      ) {
        url = "/get-manufacturing-details";
      }

      const payload = {
        selectedFilterType: selectedFilterType || null,
        // selectedRecordType: selectedRecordType || null,
        // locationId: selectedFilterType === "By Location" ? filters.locationId || null : null,
        // supplierId: selectedFilterType === "By Supplier" ? filters.supplierId || null : null,
        // // supplierId: selectedSupplier != null ? selectedSupplier.acc_id : null,
        // employeeId: selectedFilterType === "By Employee" ? filters.employeeId || null : null,
        // itemId: selectedFilterType === "By Item" ? filters.itemId || null : null,
        // groupId: selectedFilterType === "By Group" ? filters.groupId || null : null,
        // categoryId: selectedFilterType === "By Category" ? filters.categoryId || null : null,
        userId: selectedFilterType === "By User" ? filters.userId || null : null,
        // serialNumber: selectedFilterType === "By Item Serial" ? filters.serialNumber || "" : "",
        // tag_groupnameid: selectedFilterType === "By Tag" ? filters.tag_groupnameid || null : null,
        // tagFeildNameid: selectedFilterType === "By Tag" ? filters.tagFeildNameid || null : null,             
        fromDate: filters.fromDate || null,
        toDate: filters.toDate || null,
      };

      const res = await postData(url, payload);     

      let mapped = [];
      if (selectedRecordType === "with item") {
  mapped = res.data.flatMap((manufacturing) =>
    manufacturing.miDetails.map((item, idx) => {
      const total = Number(manufacturing.total_amount || 0);
      const paid = Number(
        manufacturing.paid_amount ||
        manufacturing.paid_total ||
        0
      );
      const due = Number(
        manufacturing.due_amount ||
        (total - paid)
      );

      return {
        id: `${manufacturing.mf_id}-${item.item_id}-${idx}`,
        vch_no: manufacturing.mf_voucher_no,
        date: manufacturing.created_date,
        createdBy: manufacturing.full_name,
        mode: manufacturing.trans?.map((t) => t.to_acc_name).join(", ") || "",
        item: item.item_name,
        rate: Number(item.item_rate || 0).toFixed(2),
        discount: item.item_discount_per ? `${item.item_discount_per}%` : "",
        vat: item.item_tax_per ? `${item.item_tax_per}%` : "",
        qty: `${item.item_qty} ${item.unit_name || ""}`,
        total: Number(item.item_total || 0).toFixed(2),

        // ✅ paid/due correctly mapped
        paid: paid.toFixed(2),
        due: due.toFixed(2),

        // Keep raw values for grand totals
        masterQty: Number(item.item_qty || 0),
        baseQty: Number(item.retail_qty || 0),

        unitDetails: `Total : Master U. Qty = ${item.item_qty || 0}, Base U. Qty = ${item.retail_qty || 0}`,
      };
    })
  );
} else {
  mapped = res.data.map((row) => {
    const total = Number(row.total_amount || 0);
    const paid = Number(
      row.paid_amount ||
      row.paid_total ||
      0
    );
    const due = Number(
      row.due_amount ||
      (total - paid)
    );

    return {
      id: row.mf_id,
      vch_no: row.mf_voucher_no,
      date: row.created_date,
      supplier: row.acc_name,
      employee: row.employee_name,
      createdBy: row.full_name,
      mode: row.trans?.map((t) => t.to_acc_name).join(", ") || "",
      labour: Number(row.labour_cost || 0).toFixed(2),
      others: Number(row.others_cost || 0).toFixed(2),
      totalCost: Number(row.total_cost || row.total_amount || 0).toFixed(2),
      total: total.toFixed(2),
      paid: paid.toFixed(2),
      due: due.toFixed(2),
    };
  });
}


      return mapped;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

